// extracted by mini-css-extract-plugin
module.exports = {"nextPayment":"NextPayment__nextPayment__cGYaO"};